import { ThisReceiver } from '@angular/compiler';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { forkJoin, map } from 'rxjs';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { validateFileSize } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { allowOnlyNumbersValidator, onTimeChange, phoneNumberLengthValidator } from 'src/app/utils/utils.common';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.css']
})
export class AddMemberComponent implements OnInit {
  @Input() showHeading: boolean = true;
  members:any
  submitted = false;
  memberForm!: FormGroup;
  @Input() memberId:any;
  @Input() source:any;
  @Output() onSaveMember = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  profileImageURL: any;
  selectedFile: ImageSnippet | null = null;
  levelOfServiceList:any;
  preLevelOfServiceList:any
  spaceTypeMainList:any;
  spaceTypeList:any
  filteredAddonsList: any = [];
  preSpaceTypeList:any
  appointmentTypes:any;
  fundingSources:any = []
  companies:any = []
  selectedCompanies:any = [];
  timezones:any = moment.tz.names();
  maxDate = new Date();
  user:any
  timeZone: any = timeZone;
  todayDate:any;
  fundingSourceList:any;
  preFundingSource:any
  member: any;

  constructor(
    private memberService: MemberService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private uploadService: UploadService,
    private SpaceTypeService:SpaceTypeService,
    private appointmentTypeService: AppointmentTypeService,
    private levelOfService:LosService,
    private sharedDataService: SharedDataService,
    private fundingSource: FundingSourceService,
  ){}
  
  ngOnInit() {
    this.memberForm = this.fb.group({
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      displayName: [''],
      gender: ['', Validators.required],
      weight: [''],
      dateOfBirth: ['', Validators.required],
      contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      phoneNumber: ['', [phoneNumberLengthValidator]],
      email: ['', [Validators.required, Validators.email]],
      languageSpoken: [''],
      address: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required],
        zipCode: ['', Validators.required],
        aptSuiteRoom: [''],
      }, { validators: addressValidator() }),
      wmrNumber: [''],
      medicalRecordNumber: [''],
      memberType: ['standard', Validators.required],
      allowSMS: [true, Validators.required],
      privateNotes: [''],
      timeZone: [timeZone, Validators.required],
      profileImageURL: [''],
      levelOfService: ['', Validators.required],
      spaceType: ['', Validators.required],
      fundingsource: ['', Validators.required],
      prefferedTP: [''],
      responsibleParty: this.fb.group({
        name: ['', Validators.required],
        phoneNumber: ['', [Validators.required,phoneNumberLengthValidator]],
      },{ validators: allowOnlyNumbersValidator('phoneNumber') }),

      isActive: [true, Validators.required],
      appointmentType: [''],
    },{
      validators: [
        allowOnlyNumbersValidator('contactNumber'),
        allowOnlyNumbersValidator('phoneNumber'),
      ]
    });
    this.makeCompulsoryCalls();
    this.getUser();
    this.getFundingSource();
  }

  getUser() {
  this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
    if (data) {
      this.user = data;
      if (this.user?.member) {
        this.memberId = this.user.member.id;
        this.memberForm.patchValue(this.user.member)
      }
      if (this.user.timeZone) {
        this.timeZone = this.user.timeZone;
      }
      this.todayDate = [
        moment().tz(this.timeZone).startOf("day"),
        moment().tz(this.timeZone).add(7, "days").endOf("day").toDate()
      ];
    }
  })
}

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';

    this.memberForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        zipCode: zip,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  onChangeAddress() {
    this.memberForm.patchValue({
      address: {
        coords: '',
        city: '',
        state: '',
        zipCode: '',
      }
    });
  }



  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }
    
  onSave() {
    this.submitted = true;
    if (this.memberForm.invalid) {
      return;
    }
    let payload = { ...this.memberForm.value, dateOfBirth: moment(this.memberForm.value.dateOfBirth).utc().startOf('day').toISOString() };
    this.memberService.saveMember(this.memberId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.source) {
          this.onSaveMember.emit(data)
          this.onCloseModal.emit();
        } else {
          this.router.navigateByUrl(`/trips`);
        }
      }
    }, (err) => {
      sweetAlert('Error', err, 'error', 'OK');

    })
  }

  getMembersById() {
    this.memberService.getMemberById(this.memberId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.member = data;
        this.profileImageURL = data.profileImageURL;
        this.memberForm.patchValue({
          ...data,
          dateOfBirth: moment(data.dateOfBirth, 'YYYY-MM-DD'),
          fundingsource: data.fundingsource,

        })
        this.onSelectLOS(data.levelOfService)
      }
    })
  } 

  getAllAppointment() {
    this.appointmentTypeService.getPicker().pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.appointmentTypes = data.results.filter((appointment: any) => appointment.isActive === true);
      }
    })
  }
  
  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).pipe(untilDestroyed(this)).subscribe(
      ([levelOfServiceList, spaceTypeList]: any) => {
        if (spaceTypeList) {
          this.spaceTypeMainList = spaceTypeList;
        }
        if (levelOfServiceList && this.spaceTypeMainList) {
          const activeSpaceTypeLosIds = this.spaceTypeMainList.map((space: any) => space.los);
          this.levelOfServiceList = levelOfServiceList.filter((los: any) =>
            activeSpaceTypeLosIds.includes(los.id)
          );
        }
        if (this.memberId) {
          console.log("memberId in if", this.memberId)
          this.getMembersById();
        }
      },
      (error: any) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
    this.getAllAppointment()
  }

  getLevelOfService() {
    return this.levelOfService.getPicker({ isActive: true,limit:9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  getSpaceTypeList() {
    return this.SpaceTypeService.getPicker({ isActive: true,limit:9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  onSelectLOS(losId: any) {
    if (!losId) {
      this.spaceTypeList = [];
      this.memberForm.patchValue({ spaceType: '' });
      return;
    }
    this.spaceTypeList = this.spaceTypeMainList.filter((item: any) => item.los === losId);
    if (!this.spaceTypeList.some((item: any) => item.id === this.memberForm.value.spaceType)) {
      this.memberForm.patchValue({ spaceType: '' });
    }
  }

 

   toggleCompanySelection(companyId: any) {
    const index = this.selectedCompanies.indexOf(companyId);
    if (index === -1) {
      this.selectedCompanies = [...this.selectedCompanies, companyId];
    } else {
      this.selectedCompanies = this.selectedCompanies.filter((id: any) => id !== companyId);
    }
  }

  getFundingSource() {
    this.fundingSource.getPicker({ isActive: true, limit: "999" }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSourceList = data.results;
      }
    })
  }


  processFile(imageInput: any) {
    const file = imageInput.files?.[0];
   if (!validateFileSize(file)) {
        return;
      }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          console.error('Invalid file selected.');
          return;
        }
        this.uploadService.uploadMemberImageToServer(this.selectedFile).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.memberForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl
              // this.profileImageURL = uploadResult.fileUrl; 
            }
          },
          error: (uploadError) => {
            console.error('Error uploading image:', uploadError);
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  get form() {
    return this.memberForm.controls;
  }

  get addressForm() {
    return this.memberForm.controls.address as FormGroup;
  }

  get responsibleParty() {
    return this.memberForm.controls.responsibleParty as FormGroup;
  }

  getTimeRestrictions() {
    return {
      min: null, 
      max: moment().endOf('day').toISOString()
    };
  }

  }